import React from 'react';
import { MessageSquare, AlertCircle, CheckCircle, Clock } from 'lucide-react';

const complaints = [
  { id: 1, type: 'suggestion', title: 'Mejorar iluminación', status: 'pending', date: '2h ago' },
  { id: 2, type: 'complaint', title: 'Ruido en área común', status: 'inProgress', date: '5h ago' },
];

export function ComplaintsWidget() {
  const pendingCount = complaints.filter(c => c.status === 'pending').length;
  const inProgressCount = complaints.filter(c => c.status === 'inProgress').length;

  return (
    <div className="space-y-3">
      {/* Summary */}
      <div className="grid grid-cols-2 gap-3">
        <div className="bg-red-50 rounded-lg p-3 text-center">
          <p className="text-2xl font-bold text-red-600">{pendingCount}</p>
          <p className="text-xs text-red-600">Pendientes</p>
        </div>
        <div className="bg-yellow-50 rounded-lg p-3 text-center">
          <p className="text-2xl font-bold text-yellow-600">{inProgressCount}</p>
          <p className="text-xs text-yellow-600">En proceso</p>
        </div>
      </div>

      {/* Recent Items */}
      <div className="space-y-2">
        {complaints.map((item) => (
          <div key={item.id} className="flex items-start gap-3 p-2 hover:bg-gray-50 rounded-lg transition-colors">
            {item.type === 'suggestion' ? (
              <MessageSquare className="w-4 h-4 text-blue-500 mt-0.5" />
            ) : (
              <AlertCircle className="w-4 h-4 text-orange-500 mt-0.5" />
            )}
            <div className="flex-1 min-w-0">
              <p className="text-sm font-medium text-gray-900 truncate">{item.title}</p>
              <div className="flex items-center gap-2 mt-1">
                {item.status === 'pending' ? (
                  <span className="flex items-center gap-1 text-xs text-red-600">
                    <Clock className="w-3 h-3" /> Pendiente
                  </span>
                ) : (
                  <span className="flex items-center gap-1 text-xs text-yellow-600">
                    <CheckCircle className="w-3 h-3" /> En proceso
                  </span>
                )}
                <span className="text-xs text-gray-400">• {item.date}</span>
              </div>
            </div>
          </div>
        ))}
      </div>

      <button className="w-full py-2 text-sm font-medium text-[#36CCD8] hover:text-[#2DB8C4] hover:bg-[#36CCD8]/5 rounded-lg transition-colors">
        Ver todas las quejas →
      </button>
    </div>
  );
}

export default ComplaintsWidget;
